import { createSlice } from "redux-starter-kit";

export const searchBarSlice = createSlice({
  slice: "searchbar",
  initialState: {
    isTitleOnly: 0,
  },
  reducers: {
    setTitleOnly: (state, action) => {
      state.isTitleOnly = action.payload;
    },
  },
});
